var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.listTitle,
        "show-filter": true,
        "show-refresh": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { "toggle-filter": _vm.toggleFilter, refresh: _vm.onRefresh },
    },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "secondaryActions" }, [
        _c(
          "div",
          [
            _c(
              "b-collapse",
              {
                staticClass: "mt-3",
                model: {
                  value: _vm.displayFilter,
                  callback: function ($$v) {
                    _vm.displayFilter = $$v
                  },
                  expression: "displayFilter",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "bg-white border rounded p-3" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "g-3 mb-3" },
                      [
                        _c("b-col", { attrs: { sm: "6", lg: "4" } }, [
                          _c(
                            "div",
                            { staticClass: "bg-light border rounded p-3" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-label font-weight-bold text-muted mb-2",
                                  attrs: { for: "bic-filter-code" },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-university mr-2",
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.bic.bic_code")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.BicCode,
                                    expression: "BicCode",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "bic-filter-code",
                                  type: "text",
                                  placeholder: _vm.$t("common.bic.bic_code"),
                                  "aria-label":
                                    _vm.$t("filter.search_by") +
                                    " " +
                                    _vm.$t("common.bic.bic_code"),
                                },
                                domProps: { value: _vm.BicCode },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.BicCode = $event.target.value.trim()
                                    },
                                    _vm.applyFilter,
                                  ],
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end" },
                      [
                        _c("app-button", {
                          attrs: {
                            text: _vm.$t("filter.clr_fltr_field"),
                            variant: "light",
                            icon: "fa-light fa-eraser",
                            disabled: !_vm.BicCode,
                          },
                          on: { click: _vm.clearFilterFields },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start mb-3" },
              [
                _c(
                  "b-col",
                  [
                    _c("app-button", {
                      attrs: {
                        text: _vm.$t("common.bic.bic_add"),
                        icon: "fa-light fa-plus",
                        variant: "secondary",
                      },
                      on: { click: _vm.actionAdd },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-row", { staticClass: "justify-content-center mb-5" }, [
              _c(
                "div",
                [
                  _vm.activateSpinner
                    ? _c("spinner")
                    : _vm.listItemsBic.length > 0
                    ? _c("b-table", {
                        key: _vm.refreshKey,
                        staticClass: "table-striped",
                        attrs: {
                          items: _vm.listItemsBic,
                          fields: _vm.fields,
                          "sort-by": _vm.sortBy,
                          fixed: "",
                          hover: "",
                          selectable: _vm.listItemsBic.length > 0,
                          "empty-text": _vm.$t("common.security.no_result"),
                          caption: _vm.$t("common.bic.bic_list_caption"),
                          "caption-top": "",
                          role: "table",
                          "aria-label": "Liste des codes BIC",
                          "sticky-header": "",
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "row-selected": _vm.onRowSelected,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(BicCode)",
                            fn: function (data) {
                              return [_c("span", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                          {
                            key: "cell(edit)",
                            fn: function (data) {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link text-center d-inline-block py-3 w-100",
                                    attrs: {
                                      "aria-label":
                                        _vm.$t("common.edit") +
                                        " " +
                                        data.item.BicCode,
                                      type: "button",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionEdit(
                                          $event,
                                          data.item.IdBic
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-pencil",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(delete)",
                            fn: function (data) {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link text-center d-inline-block py-3 w-100",
                                    attrs: {
                                      "aria-label":
                                        _vm.$t("common.delete") +
                                        " " +
                                        data.item.BicCode,
                                      type: "button",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionDelete(
                                          $event,
                                          data.item.IdBic
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-trash",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      })
                    : _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("span", { staticClass: "noResult" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.no_result")) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }